module.exports = __webpack_public_path__ + "static/media/mongodb-logo.541dcec4.png";